import { getProductFeaturesForNonPdpPage } from './get-product-features-for-non-pdp-page';
import { submitMerge } from '@otto-ec/tracking-bct';

export const addNonPdpFeaturesToPageImpression = (variationId: string) => {
    submitMerge(
        {}, /*                          */
        getProductFeaturesForNonPdpPage(variationId)
    );
};
